/**
 * 将十六进制的颜色转换为 RGBA 格式
 * @param hex {String} 十六进制颜色格式，例如：#ffffff00
 * @returns {Array} RGBA 颜色，例如：[255, 255, 255, 255]
 */
export function hex2rgba(hex) {
  const result = [];
  for (let i = 1; i < hex.length; i += 2) {
    result.push(parseInt(hex[i] + hex[i + 1], 16));
  }
  return result;
}

/**
 * 根据背景色将 RGBA 颜色转换为 RGB 颜色
 * @param hex {String} 十六进制颜色格式，例如：#ffffff00
 * @param [bg] {Number} 背景颜色，例如 255
 * @returns {string} RGB 颜色，例如：rgb(255, 255, 255)
 */
export function rgba2rgb(hex, bg = 255) {
  let sources = hex2rgba(hex), alpha = sources[sources.length - 1] / 255;
  let result = [];
  for (let i = 0; i < 3; i++) {
    result.push(Math.round(((1 - alpha) * bg) + (alpha * sources[i])));
  }
  return 'rgb(' + result.join(', ') + ')';
}

/**
 * 传入解析markdown格式
 */
export function formatMarkdown(text) {
  // 处理换行和段落
  text = text.replace(/\n\n/g, "</p><p>");
  text = text.replace(/\n/g, "<br>");
  // 处理标题
  text = text.replace(/^# (.*$)/gm, "<h1>$1</h1>");
  text = text.replace(/^## (.*$)/gm, "<h2>$1</h2>");
  text = text.replace(/^### (.*$)/gm, "<h3>$1</h3>");

  // 处理粗体
  text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  // 处理斜体
  // text = text.replace(/\*(.*?)\*/g, "<em>$1</em>");
  // text = text.replace(/_(.*?)_/g, "<em>$1</em>");

  // 处理代码块
  text = text.replace(
      /```([a-z]*)\n([\s\S]*?)```/g,
      '<pre><code class="$1">$2</code></pre>'
  );
  text = text.replace(/`(.*?)`/g, "<code>$1</code>");

  // 处理链接
  text = text.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');
  // 处理水平线 (---)
  text = text.replace(/^---$/gm, "<hr>");
  // 处理图片
  text = text.replace(/!\[(.*?)\]\((.*?)\)/g, '<img src="$2" alt="$1">');

  // 处理无序列表
  text = text.replace(/-\s+(.*?)(?=\s*[-*+]|\s*$)/g, "<li>$1</li>");
  text = text.replace(/(<li>.*<\/li>)+/g, function (match) {
    return "<ul>" + match + "</ul>";
  });
  // console.log(text,777)


  // 处理有序列表
  text = text.replace(/^\s*\d+\.\s(.*$)/gm, "<li>$1</li>");
  text = text.replace(/(<li>.*<\/li>\n)+/g, function (match) {
    return "<ol>" + match + "</ol>";
  });


  // 处理引用
  text = text.replace(/^>\s(.*$)/gm, "<blockquote>$1</blockquote>");

  

  return text;
}
